import { parseBooleanValue } from "../../util";
import { IIndexTypeAttribute } from "../model/IndexTypeAttribute";

const IndexTypeAttributeParamMapper = (item: IIndexTypeAttribute) => {
  return {
    ...item,
    required: parseBooleanValue(item.required),
    valid: parseBooleanValue(item.valid)
  };
};

export default IndexTypeAttributeParamMapper;
